






























import { Prop, ProvideReactive } from 'vue-property-decorator'
import { Component, mixins } from '@niknevis/vue-modules'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { DatePresetTypes, Filter, FilterTypes } from '@/modules/common/filter/filter'
import AdminUserSearchFilter from '@/modules/user/components/admin/AdminUserSearchFilter.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import QTable from 'quasar/src/components/table/QTable.js';
import TableExportButton from '@/modules/common/table-export/components/TableExportButton.vue'
import { contentStatisticsCollectionType } from '@/modules/content-statistics/models/content-statistics.collection'
import { adminContentIStatisticsTableColumns } from '@/modules/content-statistics/models/columns/content-statistics.column'
import AdminContentStatisticsTableRow from '@/modules/content-statistics/components/admin/table/AdminContentStatisticsTableRow.vue'
import { AdminContentStatisticsRoute } from '@/modules/content-statistics/routes/admin-content.statistics.route.ts'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'آمار نگارش'
  },
  metaInfo: {
    title: 'آمار نگارش'
  },
  components: {
    TableExportButton,
    TesTable,
    PaginationWithInput,
    FilterRow
  }
})
export default class AdminContentItemIndexPage extends mixins(QsSearchableMixin) {
  constructor(
    private readonly statisticsRoute: AdminContentStatisticsRoute
  ) {
    super()
  }

  @ProvideReactive()
  @Prop()
  contentStatistics!: contentStatisticsCollectionType
  protected columns: QTable['columns'] = adminContentIStatisticsTableColumns()
  private rowComponent = AdminContentStatisticsTableRow

  private filters = [
    new Filter({
      type: FilterTypes.Custom,
      component: AdminUserSearchFilter,
      title: 'کاربر',
      typeMode: false,
      key: 'user',
      props: {
        placeholder: 'جستجو کاربر'
      }
    }),
    new Filter({
      type: FilterTypes.ComboBox,
      title: 'نقش کاربر',
      key: 'roles',
      default: null,
      holder: 'همه نقش‌ها',
      typeMode: false,
      items: [{ value: '6', label: 'نویسنده' }, { value: '5', label: 'سرپرست تولید محتوا' }]
    }),
    new Filter({
      type: FilterTypes.DateRange,
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.tomorrow,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.currentMonth,
        DatePresetTypes.custom
      ],
      title: 'تاریخ',
      holder: 'انتخاب کنید',
      keys: {
        from: 'period_from',
        to: 'period_to'
      }
    })
  ]

  protected get model(): any {
    return this.contentStatistics
  }

}
